import SupportService from '../support';
import {
  GET_USER_LIST,
  GET_COMPANIES_IN_MODERATED,
  ACCEPT_COMPANY,
  COMPANIES,
  BAN_COMPANY,
  GET_CASTINGS_IN_MODERATED,
  ACCEPT_CASTING,
  DECLINE_CASTING,
  CATEGORIES,
  GET_USER_DATA,
  GET_MODERATED_INFO,
  GET_APPLICANT_CASTINGS,
  CHANGE_SUBSCRIBE_STATUS,
  GET_EMPLOYER_CASTINGS,
  GET_CASTINGS_COMPNAY,
  GET_DECLINED_COMPANIES,
  GET_DECLINED_CASTINGS,
  CASTINGS,
  ADD_CASTING_TO_ARCHIVE,
  RESUME_CASTING_FROM_ARCHIVE,
  GET_CASTINGS,
} from '../config';

export default class AdminService {
  /**
   * Getting users by role
   */
  static async getUsersList(role, page = 1, directionStr = 'desc', category = '') {
    try {
      return await SupportService.post(`${GET_USER_LIST}`, { role, page, size: 16, directionStr, category });
    } catch (err) {
      console.error('ERROR', err);
    }
  }

  /**
   * Getting companies list
   */
  static async getAllCompanies(page = 1, directionStr = 'desc') {
    try {
      return await SupportService.get(`${COMPANIES}?size=16&page=${page}&directionStr=${directionStr}`);
    } catch (err) {
      console.error('ERROR', err);
    }
  }

  /**
   * Getting company by id
   */
  static async getCompany(id) {
    try {
      return await SupportService.get(`${COMPANIES}?companyId=${id}`);
    } catch (err) {
      console.error('ERROR', err);
    }
  }

  /**
   * Getting companies awaiting moderation
   */
  static async getCompaniesInModerated(page = 1, directionStr = 'desc') {
    try {
      return await SupportService.post(GET_COMPANIES_IN_MODERATED, { size: 16, page, directionStr });
    } catch (err) {
      console.error('ERROR', err);
    }
  }

  /**
   * Accept company
   */
  static async acceptCompany(companyId) {
    try {
      return await SupportService.post(ACCEPT_COMPANY, companyId);
    } catch (err) {
      console.error('ERROR', err);
    }
  }

  /**
   * Ban company
   */
  static async banCompany(companyId) {
    try {
      return await SupportService.post(BAN_COMPANY, companyId);
    } catch (err) {
      console.error('ERROR');
    }
  }

  /**
   * Getting castings awaiting moderation
   */
  static async getCastingsInModerated(page = 1, directionStr = 'desc', mainCategory = '') {
    try {
      return SupportService.post(GET_CASTINGS_IN_MODERATED, { page, directionStr, mainCategory });
    } catch (err) {
      console.error('ERROR');
    }
  }

  /**
   * Getting castings list
   */
  static async getAllCastings(page = 1, directionStr = 'desc', mainCategory = '') {
    try {
      return SupportService.post(`${GET_CASTINGS}?page=${page}&directionStr=${directionStr}&mainCategory=${mainCategory}`);
    } catch (err) {
      console.error('ERROR');
    }
  }

  /**
   * Getting archived castings
   */
  static async getArchivedCastings(page = 1, directionStr = 'desc', mainCategory = '') {
    try {
      return SupportService.post(GET_CASTINGS_IN_MODERATED, { page, status: 'archive', directionStr, mainCategory });
    } catch (err) {
      console.error('ERROR');
    }
  }

  /**
   * Accept casting
   */
  static async acceptCasting(castingId) {
    try {
      return SupportService.post(ACCEPT_CASTING, castingId);
    } catch (err) {
      console.error('ERROR');
    }
  }

  /**
   * Decline casting
   */
  static async declineCasting(castingId) {
    try {
      return SupportService.post(DECLINE_CASTING, castingId);
    } catch (err) {
      console.error('ERROR');
    }
  }

  /**
   * Get categories list
   */
  static async getAllCategories() {
    try {
      return SupportService.get(CATEGORIES);
    } catch (err) {
      console.error('ERROR');
    }
  }

  /**
   * Get user data by id
   */
  static async getUserDataByUid(id) {
    try {
      return SupportService.get(`${GET_USER_DATA}?userId=${id}`);
    } catch (err) {
      console.error('ERROR');
    }
  }

  /**
   * Get all total statistic by users, companies, castings and other
   */
  static async getModeratedInfo() {
    try {
      return SupportService.get(GET_MODERATED_INFO);
    } catch (err) {
      console.error('ERROR');
    }
  }

  /**
   * Get user catsings by uid
   */
  static async getApplicantCastings(uid) {
    try {
      return SupportService.get(`${GET_APPLICANT_CASTINGS}?uid=${uid}`);
    } catch (err) {
      console.error('ERROR');
    }
  }

  /**
   * Get employer catsings by uid
   */
  static async getEmployerCastings(uid) {
    try {
      return SupportService.get(`${GET_EMPLOYER_CASTINGS}?uid=${uid}`);
    } catch (err) {
      console.error('ERROR');
    }
  }

  static async getCastingsByCompanyId(uid) {
    try {
      return SupportService.get(`${GET_CASTINGS_COMPNAY}?companyId=${uid}`);
    } catch (err) {
      console.error('ERROR');
    }
  }

  static async giveOutFullVersion(uid) {
    console.log(uid);
    try {
      return SupportService.post(CHANGE_SUBSCRIBE_STATUS, uid);
    } catch (err) {
      console.error('ERROR');
    }
  }

  /**
   * Getting declined companies
   */
  static async getDeclinedCompanies(page = 1, directionStr = 'desc') {
    try {
      return await SupportService.get(`${GET_DECLINED_COMPANIES}?page=${page}&size=16&directionStr=${directionStr}`);
    } catch (err) {
      console.error('ERROR', err);
    }
  }

  /**
   * Getting declined castings
   */
  static async getDeclinedCastings(page = 1, directionStr = 'desc', mainCategory = '') {
    try {
      return await SupportService.get(`${GET_DECLINED_CASTINGS}?page=${page}&size=16&directionStr=${directionStr}&mainCategory=${mainCategory}`);
    } catch (err) {
      console.error('ERROR', err);
    }
  }
  
  static async updateCasting(id, data) {
    try {
      return SupportService.put(CASTINGS, {
        castingId: id,
        castingData: data,
      });
    } catch (err) {
      console.log('ERROR');
    }
  }

  static async deleteCasting(id) {
    try {
      return SupportService.delete(CASTINGS, {
        castingId: id,
      });
    } catch (err) {
      console.log('ERROR');
    }
  }

  static async addCastingToArchive(id) {
    try {
      return SupportService.post(ADD_CASTING_TO_ARCHIVE, {
        castingId: id,
      });
    } catch (err) {
      console.log('ERROR');
    }
  }

  static async resumeCastingFromArchive(id) {
    try {
      return SupportService.post(RESUME_CASTING_FROM_ARCHIVE, {
        castingId: id,
      });
    } catch (err) {
      console.log('ERROR');
    }
  }

  static async deleteUser(id) {    
    try {
      return SupportService.delete(GET_USER_DATA, {
        userId: id,
      });
    } catch (err) {
      console.log('ERROR');
    }
  }
}
